<div class="role-level-selector" role="radiogroup" [attr.aria-label]="ariaLabel()">
  @for (option of options(); track option.value) {
    <tf-settings-role-grants-popover
      class="role-level-selector__option"
      [trigger]="shouldShowGrantPopover(option)"
      [openOnClick]="false"
      [openOnFocus]="false"
      [hoverOpenDelayMs]="250"
      [title]="ariaLabel()"
      [level]="optionLevel(option)"
      [grants]="optionGrants(option)">
      <span
        class="role-level-selector__option-inner"
        [pTooltip]="option.disabled ? (option.disabledTooltip ?? '') : ''"
        tooltipPosition="top">
        <button
          type="button"
          role="radio"
          [class.role-level-selector__button--active]="option.value === value()"
          [attr.aria-checked]="option.value === value()"
          [disabled]="disabled() || option.disabled"
          (click)="selectOption(option)">
          {{ option.label }}
        </button>
      </span>
    </tf-settings-role-grants-popover>
  }
</div>
